/* eslint-disable */

export default {
  calc: function({ ctx }){
    var currentAge = ctx.$store.getters.selectedCurrentAge
    var agePaymentsStart = ctx.$store.getters.selectedAgePaymentsStart
    var country = ctx.$store.getters.selectedCountry
    var gender = ctx.$store.getters.selectedGender
    var lifeExpectancy = Math.round(
      ctx.$store.getters.lifeExpectancy
    )
    var annualPayments = Math.round(ctx.$store.getters.annualPayments)
    var interest = parseFloat(ctx.$store.getters.interest)
    var salesPercentCost = parseFloat(ctx.$store.getters.salesPercentCost)
    var adminCostDuringPayments =
      parseFloat(ctx.$store.getters.adminCostDuringPayments)
    var adminCostBeforePayements =
      parseFloat(ctx.$store.getters.adminCostOutsidePayements)

    var breakDown = []
    for (var year = currentAge; year<=lifeExpectancy; year++) {
      var data = { year: parseInt(year) }
      if (year == currentAge) {
        data.salesCost = Math.round(salesPercentCost*annualPayments)
        data.adminCosts = 0
        data.payment = 0
      } else if (year != currentAge && year < agePaymentsStart) {
        data.salesCost = 0
        data.adminCosts = Math.round(adminCostBeforePayements*annualPayments)
        data.payment = 0
      } else if (year >= agePaymentsStart) {
        data.salesCost = 0
        data.adminCosts = Math.round(adminCostDuringPayments*annualPayments)
        data.payment = annualPayments
      }
      data.totalCost = data.salesCost + data.adminCosts + data.payment
      data.PVofCosts = Math
        .round(data.totalCost/Math.pow(1+interest, year - currentAge))
      breakDown.push(data)
    }
    var outcome = {}
    outcome.SalesCost = breakDown.reduce((acc, cur)=>acc+cur.salesCost, 0)
    outcome.PVofCosts = breakDown.reduce((acc, cur)=>acc+cur.PVofCosts, 0)
    outcome.adminTotal = breakDown.reduce((acc, cur)=>acc+cur.adminCosts, 0)
    outcome.paymentsTotal = breakDown.reduce((acc, cur)=>acc+cur.payment, 0)

    var capitalResults = []
    for (var year = currentAge; year<=lifeExpectancy; year++) {
      var capitalData = {}
      if(year == currentAge) {
        capitalData.capital =
          Math.round(ctx.$store.getters.reserveCapRate*outcome.PVofCosts)
      } else {
        capitalData.capital = capitalResults[year-currentAge-1].endOfYear
      }
      capitalData.return = Math.round(capitalData.capital * interest)
      capitalData.endOfYear = capitalData.capital + capitalData.return
      capitalResults.push(capitalData)
    }

    outcome.costs = outcome.PVofCosts +
      Math.round(ctx.$store.getters.reserveCapRate*outcome.PVofCosts + (1 * interest))

    ctx.$store.commit('setResult', {
      totalCosts: outcome.costs,
      admin: outcome.adminTotal,
      salesCost: outcome.SalesCost,
      payments: outcome.paymentsTotal,
      currentAge: currentAge,
      agePaymentsStart: agePaymentsStart,
      country: country,
      gender: gender,
      annualPayments: annualPayments,
      lifeExpectancy: lifeExpectancy,
      breakDown: breakDown,
      reserveCapAmount: ctx.$store.getters.reserveCapRate*outcome.PVofCosts
    })
  },
}
/* eslint-enable */
